export default __webpack_public_path__ + "static/ClubAutomationWhiteSmall-15bb78f232e6c6fcb257b7532fceae5d.png";